import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const oddsButtonSizeObj = {
  height: 38,
  heightMo: 35,
  widthLg: 38,
  widthMo: 60,
  widthSm: 34,
};

export const BookmakerSeparator = styled.div`
  min-width: 1px;
  max-width: 1px;
  height: 100%;
  background: transparent;
  display: none;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: block;
    }
  }
`;

export const squareIcon = `
  --oc-info-square-background: var(--oc-primary-white);
  --oc-info-square-size: 8;

  display: inline-block;
  width: calc(var(--oc-info-square-size) * 1px);
  height: calc(var(--oc-info-square-size) * 1px);
  background-color: inherit;
  border-radius: 2px;
`;

export const quickBetIcon = css`
  display: flex;
  border-radius: 50%;
  margin-right: 5px;
`;

export const tooltipStyles = css`
  width: 250px;
  max-width: 250px;
  display: inline-block;
  white-space: normal;
`;

export const gridExpanderTipStyles = css`
  pointer-events: visible !important;
  width: 354px;
  color: var(--oc-text-white);
  flex-grow: 0;
  margin: 5px 10px 10px;
  padding: 20px 15px 20px 14px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #4285f4;
  font-family: var(--ogm-font-family-2);
  border-radius: 5px;
  z-index: var(--cxy-z-index-control-high);
`;

export const gridExpanderTipArrow = css`
  fill: #4285f4;
`;

export const OddsInfoItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 0;
  height: 15px;
  color: var(--ogm-text-body);

  &:hover {
    cursor: pointer;
  }
`;

export const InfoLabel = styled.span`
  font-family: var(--ogm-font-family-2);
  font-style: normal;
  font-weight: 500px;
  font-size: 12px;
  line-height: 15px;
  margin-right: 5px;
  user-selection: none;
`;

export const StyledQuickBetIcon = styled.span`
  position: relative;
  top: -7px;
  left: 11px;
`;
